export default defineAppConfig({
  ui: {
    colors: {
      primary: 'green',
      neutral: 'zinc'
    },

    // Nuxt UI's own skeleton ships as `animate-pulse rounded-md bg-elevated`
    // — a flat gray block that pulses. Every <USkeleton> in the app (the
    // tables in ColorsTable / ModelsGroupedTable / SearchableFilteredTable,
    // the sidebar avatar, the setup flow) therefore looked nothing like the
    // brand shimmer used by AppSkeleton, TableSkeleton and friends.
    //
    // Retheming it here is a one-line fix for all of them: `azzad-shimmer`
    // (see the loading & motion block in assets/css/main.css) supplies the
    // tint and the travelling sheen, and `animate-none` cancels the inherited
    // pulse so the two treatments don't run at once. The inherited
    // `bg-elevated` is superseded by `.azzad-shimmer`'s own background-color,
    // which is declared after the Tailwind and Nuxt UI imports in main.css.
    //
    // Per-instance sizing/rounding still comes from each call site's `class`.
    skeleton: {
      base: 'azzad-shimmer animate-none'
    }
  }
})
